import { render, staticRenderFns } from "./StatisticTableViewCountry.vue?vue&type=template&id=741c14aa&scoped=true"
import script from "./StatisticTableViewCountry.vue?vue&type=script&lang=js"
export * from "./StatisticTableViewCountry.vue?vue&type=script&lang=js"
import style0 from "./StatisticTableViewCountry.vue?vue&type=style&index=0&id=741c14aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741c14aa",
  null
  
)

export default component.exports